import { render, staticRenderFns } from "./AppLanguageSwitch.vue?vue&type=template&id=182bcbf7&scoped=true"
import script from "./AppLanguageSwitch.vue?vue&type=script&lang=js"
export * from "./AppLanguageSwitch.vue?vue&type=script&lang=js"
import style0 from "./AppLanguageSwitch.vue?vue&type=style&index=0&id=182bcbf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182bcbf7",
  null
  
)

export default component.exports